export default __webpack_public_path__ + "static/media/dashboard_white.6e5943ca.svg";